export default "__VITE_ASSET__DoXa1An2__"